(() => {
  const root = window.Shopify?.routes?.root || '/';
  const messages = document.body.dataset;
  const toast = document.querySelector('[data-toast]');
  let toastTimer;
  let cartVersion = 0;
  let cartQueue = Promise.resolve();

  function announce(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.hidden = true; }, 4500);
  }

  function showDialog(id, trigger) {
    const dialog = document.getElementById(id);
    if (!dialog?.showModal) return false;
    if (!dialog.open) dialog.showModal();
    dialog.returnFocus = trigger;
    return true;
  }

  function updateCartFragment(html) {
    if (typeof html !== 'string') throw new Error(messages.error);
    const dom = new DOMParser().parseFromString(html, 'text/html');
    const fragment = dom.querySelector('[data-cart-fragment]');
    if (!fragment) throw new Error(messages.error);
    document.querySelector('[data-cart-content]')?.replaceChildren(fragment);
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = fragment.dataset.count; });
  }

  async function refreshCart() {
    const version = ++cartVersion;
    const response = await fetch(`${root}?sections=cart-panel`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(messages.error);
    const sections = await response.json();
    if (version === cartVersion) updateCartFragment(sections['cart-panel']);
  }

  function enqueueCart(task) {
    const result = cartQueue.then(task, task);
    cartQueue = result.catch(() => {});
    return result;
  }

  async function changeCart(key, quantity, trigger) {
    const dialog = document.getElementById('CartDialog');
    dialog?.setAttribute('aria-busy', 'true');
    const content = document.querySelector('[data-cart-content]');
    content?.querySelectorAll('button,input').forEach(el => { el.disabled = true; });
    try {
      ++cartVersion;
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: ['cart-panel'], sections_url: location.pathname })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || messages.error);
      if (data.sections?.['cart-panel']) updateCartFragment(data.sections['cart-panel']);
      else await refreshCart();
      const next = document.querySelector(`[data-cart-key="${CSS.escape(key)}"]`);
      if (next && trigger?.tagName === 'INPUT') next.focus();
    } catch (error) {
      const status = document.querySelector('[data-cart-error]');
      if (status) status.textContent = error.message;
      announce(error.message);
    } finally {
      dialog?.removeAttribute('aria-busy');
      content?.querySelectorAll('button,input').forEach(el => { el.disabled = false; });
    }
  }

  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-open-dialog]');
    if (opener && showDialog(opener.dataset.openDialog, opener)) {
      event.preventDefault();
      document.querySelectorAll('[data-menu][open]').forEach(el => { el.open = false; });
      if (opener.dataset.openDialog === 'CartDialog') enqueueCart(refreshCart).catch(error => {
        const area = document.querySelector('[data-cart-content]');
        if (area) { area.replaceChildren(); const link = document.createElement('a'); link.href = `${root}cart`; link.textContent = messages.cartFallback; link.className = 'button button-dark'; area.append(link); }
        announce(error.message);
      });
    }
    const close = event.target.closest('[data-close-dialog]');
    if (close) close.closest('dialog')?.close();
    const remove = event.target.closest('[data-remove-key]');
    if (remove) {
      event.preventDefault();
      if (remove.closest('dialog')?.getAttribute('aria-busy') !== 'true') enqueueCart(() => changeCart(remove.dataset.removeKey, 0, remove));
    }
    if (event.target.matches('[data-menu] a')) event.target.closest('[data-menu]').open = false;
    if (!event.target.closest('[data-menu]')) document.querySelectorAll('[data-menu][open]').forEach(el => { el.open = false; });
  });

  document.querySelectorAll('dialog').forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => { dialog.returnFocus?.focus(); });
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('[data-menu][open],.filters[open]').forEach(el => { el.open = false; });
  });

  document.addEventListener('change', event => {
    const quantity = event.target.closest('[data-cart-key]');
    if (quantity && quantity.checkValidity()) enqueueCart(() => changeCart(quantity.dataset.cartKey, Number(quantity.value), quantity));
    if (event.target.matches('#SortBy')) event.target.form?.requestSubmit();
  });

  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.matches('[data-drawer-form]') && event.submitter?.name !== 'checkout') {
      event.preventDefault();
      enqueueCart(async () => {
        const status = form.querySelector('[data-cart-error]');
        try {
          const updates = {};
          form.querySelectorAll('[data-cart-key]').forEach(input => { updates[input.dataset.cartKey] = Number(input.value); });
          ++cartVersion;
          const response = await fetch(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates, sections: ['cart-panel'], sections_url: location.pathname }) });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || messages.error);
          if (data.sections?.['cart-panel']) updateCartFragment(data.sections['cart-panel']);
          else await refreshCart();
        } catch (error) { if (status) status.textContent = error.message; }
      });
    }
    if (form.matches('td-product .product-form')) {
      const button = event.submitter || form.querySelector('[data-add-button]');
      event.preventDefault();
      if (!button || button.disabled || form.querySelector('input[name="id"]')?.disabled) return;
      const wantsCheckout = button.matches('[data-buy-now]');
      const purchaseButtons = [...form.querySelectorAll('[data-add-button], [data-buy-now]')];
      if (form.getAttribute('aria-busy') === 'true') return;
      form.setAttribute('aria-busy', 'true');
      purchaseButtons.forEach(control => { control.disabled = true; });
      const status = form.querySelector('[data-form-status]');
      if (status) status.textContent = messages.adding;
      const body = new FormData(form);
      body.set('sections', 'cart-panel');
      body.set('sections_url', location.pathname);
      enqueueCart(async () => {
        try {
          ++cartVersion;
          const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || messages.error);
          if (wantsCheckout) { location.assign(`${root}checkout`); return; }
          if (status) status.textContent = messages.added;
          if (data.sections?.['cart-panel']) updateCartFragment(data.sections['cart-panel']);
          else { try { await refreshCart(); } catch { location.assign(`${root}cart`); return; } }
          showDialog('CartDialog', button);
        } catch (error) { if (status) status.textContent = error.message; announce(error.message); }
        finally { form.removeAttribute('aria-busy'); purchaseButtons.forEach(control => { control.disabled = false; }); }
      });
    }
  });

  class TDProduct extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('change', event => { if (event.target.matches('[data-option-input]')) this.selectVariant(event.target); });
    }
    disconnectedCallback() { this.controller?.abort(); }
    async selectVariant(input) {
      this.controller?.abort();
      this.controller = new AbortController();
      const choices = [...this.querySelectorAll('[data-option-input]:checked')].map(el => el.dataset.optionValueId).join(',');
      const url = new URL(this.dataset.url, location.origin);
      url.searchParams.set('option_values', choices);
      url.searchParams.set('section_id', this.dataset.section);
      const selectedId = input.id;
      const productInfo = this.querySelector('[data-product-info]');
      productInfo?.setAttribute('aria-busy', 'true');
      this.querySelectorAll('[data-add-button], [data-buy-now]').forEach(button => { button.disabled = true; });
      try {
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error(this.dataset.error);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextProduct = html.querySelector('td-product');
        const nextInfo = nextProduct?.querySelector('[data-product-info]');
        if (!nextInfo) throw new Error(this.dataset.error);
        const focused = document.activeElement?.id === selectedId;
        productInfo.replaceWith(nextInfo);
        if (focused) this.querySelector(`#${CSS.escape(selectedId)}`)?.focus({ preventScroll: true });
        const variant = nextInfo.querySelector('input[name="id"]')?.value;
        const browserUrl = new URL(location.href);
        browserUrl.searchParams.delete('option_values');
        if (variant) browserUrl.searchParams.set('variant', variant);
        else { browserUrl.searchParams.delete('variant'); browserUrl.searchParams.set('option_values', choices); }
        history.replaceState({}, '', browserUrl);
        const mediaId = nextProduct.dataset.selectedMedia;
        if (mediaId) {
          const media = this.querySelector(`#Media-${CSS.escape(this.dataset.section)}-${CSS.escape(mediaId)}`);
          if (media) {
            const gallery = this.querySelector('td-product-gallery');
            if (gallery?.desktop?.matches) gallery.selectMedia(media.id);
            else this.querySelector('[data-product-gallery]')?.prepend(media);
          }
        }
      } catch (error) {
        if (error.name === 'AbortError') return;
        location.assign(url.href.replace(/[?&]section_id=[^&]+/, ''));
      } finally { productInfo?.removeAttribute('aria-busy'); }
    }
  }

  class TDCountdown extends HTMLElement {
    connectedCallback() {
      clearInterval(this.timer);
      const dateString = this.dataset.deadline;
      const validZone = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(Z|[+-]\d{2}:\d{2})$/.test(dateString || '');
      this.deadline = validZone ? Date.parse(dateString) : NaN;
      if (!Number.isFinite(this.deadline)) {
        if (!window.Shopify?.designMode) this.closest('.drop-panel')?.setAttribute('hidden', '');
        return;
      }
      const label = this.querySelector('[data-date-label]');
      if (label) label.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'es', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: this.dataset.timezone || 'America/Guayaquil', timeZoneName: 'short' }).format(new Date(this.deadline));
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    tick() {
      const remaining = Math.max(0, Math.floor((this.deadline - Date.now()) / 1000));
      if (!remaining) {
        clearInterval(this.timer);
        const countdown = this.querySelector('.countdown');
        if (countdown) { countdown.textContent = this.dataset.ended; countdown.className = 'drop-ended'; countdown.removeAttribute('role'); }
        return;
      }
      const parts = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining % 86400 / 3600), minutes: Math.floor(remaining % 3600 / 60), seconds: remaining % 60 };
      for (const [key, value] of Object.entries(parts)) { const element = this.querySelector(`[data-${key}]`); if (element) element.textContent = String(value).padStart(2, '0'); }
    }
  }

  if (!customElements.get('td-product')) customElements.define('td-product', TDProduct);
  if (!customElements.get('td-countdown')) customElements.define('td-countdown', TDCountdown);
})();

(() => {
  const done = new WeakSet();
  const selector = '.product-visual img.product-image, .product-media > a > img';
  const frameImage = async (img) => {
    if (done.has(img)) return;
    done.add(img);
    try {
      if (!img.complete) await new Promise((resolve, reject) => { img.addEventListener('load', resolve, { once: true }); img.addEventListener('error', reject, { once: true }); });
      if (!img.naturalWidth) return;
      const sample = new Image();
      sample.crossOrigin = 'anonymous';
      sample.src = img.currentSrc || img.src;
      await sample.decode();
      const canvas = document.createElement('canvas');
      const w = 160, h = Math.max(1, Math.round(160 * sample.naturalHeight / sample.naturalWidth));
      if (h > 800) return;
      canvas.width = w; canvas.height = h;
      const ctx = canvas.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(sample, 0, 0, w, h);
      const pixels = ctx.getImageData(0, 0, w, h).data;
      const white = (x, y) => { const i = (y * w + x) * 4; return pixels[i + 3] < 32 || (pixels[i] > 238 && pixels[i + 1] > 238 && pixels[i + 2] > 238); };
      let border = 0, total = 0;
      for (let x = 0; x < w; x++) { total += 2; border += Number(white(x, 0)) + Number(white(x, h - 1)); }
      for (let y = 0; y < h; y++) { total += 2; border += Number(white(0, y)) + Number(white(w - 1, y)); }
      if (border / total < .94) return;
      let left = w, top = h, right = 0, bottom = 0;
      for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
        const i = (y * w + x) * 4;
        if (pixels[i + 3] > 32 && Math.min(pixels[i], pixels[i + 1], pixels[i + 2]) < 222) {
          left = Math.min(left, x); right = Math.max(right, x); top = Math.min(top, y); bottom = Math.max(bottom, y);
        }
      }
      if (right <= left || bottom <= top) return;
      const host = img.closest('.product-visual, .product-media');
      const apply = () => {
        const bw = host.clientWidth, bh = host.clientHeight;
        if (!bw || !bh) return;
        const scale = Math.min(bw * .94 / (right - left + 1), bh * .94 / (bottom - top + 1));
        Object.assign(img.style, { position: 'absolute', maxWidth: 'none', width: (w * scale) + 'px', height: (h * scale) + 'px', left: (bw / 2 - (left + right + 1) / 2 * scale) + 'px', top: (bh / 2 - (top + bottom + 1) / 2 * scale) + 'px', objectFit: 'fill', transform: 'none' });
      };
      apply();
      new ResizeObserver(apply).observe(host);
    } catch {}
  };
  const scan = () => document.querySelectorAll(selector).forEach(frameImage);
  scan();
  document.addEventListener('shopify:section:load', scan);
  new MutationObserver(scan).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
})();


(() => {
  class TDLoopVideo extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const video = this.querySelector('video');
      if (!video) return;
      this.initialized = true;
      this.visible = false;
      Object.assign(video, { muted: true, defaultMuted: true, volume: 0, loop: true, autoplay: true, playsInline: true, controls: false, disablePictureInPicture: true, disableRemotePlayback: true });
      video.setAttribute('muted', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('disablepictureinpicture', '');
      video.setAttribute('disableremoteplayback', '');
      video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
      video.removeAttribute('controls');
      video.tabIndex = -1;
      this.sync = () => {
        video.muted = true;
        video.volume = 0;
        if (this.visible && !document.hidden) video.play()?.catch(() => {});
        else video.pause();
      };
      this.ready = () => this.sync();
      video.addEventListener('canplay', this.ready);
      document.addEventListener('visibilitychange', this.sync);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          this.sync();
        }, { threshold: 0.05 });
        this.observer.observe(this);
      } else {
        this.visible = true;
        this.sync();
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.sync);
      const video = this.querySelector('video');
      video?.removeEventListener('canplay', this.ready);
      video?.pause();
      this.initialized = false;
    }
  }

  class TDRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.loaded || !this.dataset.url) return;
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.load();
        }, { rootMargin: '300px 0px' });
        this.observer.observe(this);
      } else this.load();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
    }
    async load() {
      if (this.loaded) return;
      this.loaded = true;
      this.controller = new AbortController();
      try {
        const response = await fetch(this.dataset.url, { signal: this.controller.signal, headers: { Accept: 'text/html' } });
        if (!response.ok) return;
        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = documentFragment.querySelector('td-recommendations [data-recommendation-content]');
        if (content?.querySelector('.product-card')) this.replaceChildren(content);
      } catch {}
    }
  }

  if (!customElements.get('td-loop-video')) customElements.define('td-loop-video', TDLoopVideo);
  if (!customElements.get('td-recommendations')) customElements.define('td-recommendations', TDRecommendations);
})();

(() => {
  class TDProductGallery extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.desktop = matchMedia('(min-width:750px)');
      this.panels = [...this.querySelectorAll('[data-gallery-media]')];
      this.buttons = [...this.querySelectorAll('[data-media-target]')];
      if (!this.panels.length) return;
      this.onClick = event => {
        const button = event.target.closest('[data-media-target]');
        if (button && this.contains(button)) this.selectMedia(button.dataset.mediaTarget);
      };
      this.onKey = event => {
        const index = this.buttons.indexOf(event.target.closest('[data-media-target]'));
        if (index < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.buttons.length) % this.buttons.length;
        const button = this.buttons[next];
        this.selectMedia(button.dataset.mediaTarget);
        button.focus({ preventScroll: true });
        button.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      };
      this.onViewport = () => {
        if (this.desktop.matches) this.selectMedia(this.activeId);
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
      this.desktop.addEventListener('change', this.onViewport);
      const initial = this.panels.find(panel => panel.dataset.mediaId === this.dataset.initialMedia) || this.panels[0];
      this.selectMedia(initial.id);
      this.dataset.enhanced = '';
    }
    selectMedia(id) {
      const selected = this.panels.find(panel => panel.id === id);
      if (!selected) return;
      this.activeId = id;
      this.panels.forEach(panel => {
        panel.classList.toggle('is-active', panel === selected);
        if (panel !== selected && this.desktop.matches) panel.querySelectorAll('video, model-viewer').forEach(media => media.pause?.());
      });
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === id)));
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
      this.desktop?.removeEventListener('change', this.onViewport);
      this.initialized = false;
    }
  }
  if (!customElements.get('td-product-gallery')) customElements.define('td-product-gallery', TDProductGallery);
})();
